/**
 * jv-tinymce directive
 *
 * To use tinymce directive below files are required.
 * tinymce_4.x/tinymce.min.js
 * tinymce_4.x/jquery.tinymce.min.js
 *
 * Use this directive to bind a tinymce editor to a html element
 *
 * Usage
 * <div width="200" height="200" jv-tinymce jv-tinymce-editable="jvTinymceEditable" jv-tinymce-options="{menubar:true,personalize:true,statusbar:true,smallIcons:true,displayType:'expanded'}" jv-render-on-load='jvRenderTinymceOnLoad'></div>
 *
 * jv-tinymce-options:
 * displayType: 'expanded' / 'full'
 * menubar: true/false. Default is false.
 * statusbar: true/false. Default is false.
 * smallIcons: true/false. Default is false.
 * centerAlign: true/false. Default is false
 * allHtml: true/false. Default is false.
 * dontEscapeNewline: repalce /n to br true/false

 *  To make the tinymce as a required field, just add an attribute "required" in the above template and catch the error as you would catch for a regular angular js
 *  form validation.
 eg.
 <div name="content" width="200" height="200" ng-model="content" jv-tinymce jv-tinymce-options="{smallIcons:true}" required></div>
 <div class="error" ng-show="VideoInterviewForm.$dirty && submitted && VideoInterviewForm.content.$error.required"><spring:message code="COMMON.MESSAGE.IS.REQUIRED" /></div>
 */

var __tinyCounter = 0; // <-- added: global counter to ensure unique IDs

angular.module('jv.Common.Directives.jvTinymce', [])

    .directive('jvTinymce', ['$timeout','$rootScope',
        function($timeout, rootScope) {
            var tempId = 0;
            var directiveObject = {
                restrict: 'A',
                require: 'ngModel',
                scope: {
                    message: '=jvTinymce',
                    associatedModel:'=ngModel',
                    editMode: '=jvTinymceEditable',
                    renderOnLoad: '=jvRenderOnLoad',
                    overrides: '=jvTinymceOverrides',
                    onSetup: '&jvTinymceOnSetup',
                    toolbarConfig: '@jvTinymceToolbarConfig'
                },
                link: function(scope, element, attribute, ngModel) {
                    var toolbarConfig,
                        tinymceOptions,
                        menubarConfig,
                        fontConfig,
                        styleFormatItems;
                    // tempId will be used to create tinymce instance on the element.
                    tempId = tempId + 1;
                    $(element).attr('id', 'tiny' + tempId);

                    // cleanup on destroy (fix disappearing editors on candidate switch)
                    scope.$on('$destroy', function () {
                        var id = $(element).attr('id');
                        var ed = (window.tinyMCE || window.tinymce) && (window.tinyMCE.get(id) || window.tinymce.get(id));
                        if (ed && ed.remove) ed.remove();
                    });

                    //tinymce options
                    tinymceOptions = scope.$eval(attribute.jvTinymceOptions) || {};

                    //VA: This is for angular like required validations.
                    tinymceOptions.required = attribute.required;
                    //VA: with updates also check the validity of the required.
                    if(angular.isDefined(tinymceOptions.required)){
                        ngModel.$parsers.unshift(function(viewValue){
                            var content = viewValue;
                            if(angular.isDefined(viewValue)){
                                content = content.replace(/(<([^>]+)>)/ig,'');
                                content = content.replace(/\&nbsp;/ig,'');
                            }

                            if(angular.isUndefined(viewValue)){
                                // it is invalid
                                ngModel.$setValidity('required',false);
                                return undefined;
                            }else{
                                content = content.replace(/(<([^>]+)>)/ig,'');
                                content = content.replace(/\&nbsp;/ig,'');
                                if(content === ''){
                                    ngModel.$setValidity('required',false);
                                    return undefined;
                                }else{
                                    ngModel.$setValidity('required',true);
                                    return viewValue;
                                }
                            }
                            //updateModel();
                        });
                    }

                    function updateModel() {
                        if(angular.isDefined(tinymceOptions.required)){
                            //VA: Added to support angularjs like 'required' validation.
                            ngModel.$setViewValue(rootScope.stripNewLines(element.val()));
                        }
                        scope.associatedModel = rootScope.stripNewLines(element.val());
                        if (!scope.$root.$$phase) {
                            scope.$apply();
                        }
                        stripLinksFromDuplicateDOM();
                    }

                    function updateEditor(message) {
                        var currentTinymce = element.tinymce();
                        if(currentTinymce){
                            currentTinymce.setContent(message);
                        }
                        stripLinksFromDuplicateDOM();
                    }

                    function onInit(){
                        //Upon Init, if centerAlign option is set, then append 'centerAlign' class to the editorContainer
                        if (tinymceOptions.centerAlign && element.tinymce() && element.tinymce().editorContainer) {
                            $(element.tinymce().editorContainer).addClass('centerAlign');
                        }

                        if(scope.associatedModel){
                            updateEditor(scope.associatedModel);
                        }
                        stripLinksFromDuplicateDOM();
                    }

                    var tinyMceElem = $('*[jv-tinymce]');
                    function stripLinksFromDuplicateDOM(){
                        //VA: find all the links inside the div and remove them.
                        if(tinyMceElem.length >0 ){
                            // remove all the links and styles from the tinymce div otherwise it can interfere with the page.
                            tinyMceElem.find('link').remove();
                            tinyMceElem.find('style').remove();
                        }
                    }

                    scope.$watch('associatedModel', function(newVal, oldVal) {
                        if(angular.isDefined(newVal) && newVal !== oldVal){
                            element.trigger('tinymceEdits');
                            //Updates model only when editor and model values are different.
                            if(rootScope.stripNewLines(element.val()) !== newVal) {
                                updateEditor(newVal);
                            }
                        }
                    });

                    scope.$watch('message.update', function(newVal, oldVal) {
                        if (newVal === true) {
                            updateEditor(scope.message.htmlMessage);
                            scope.message.update = false;
                        }
                        stripLinksFromDuplicateDOM();
                    });

                    //TODO-PRANAV: Do we even need editMode functionality. How is it being used?

                    // VA: native ways of enabling and disabling tinymce are not tried and tested and there is no proper solution. Below way works best for enabling disabling.
                    function enableTinymce() {
                        $($(element).parent()).find('.alpha60').remove();
                    }
                    function disableTinymce(id) {
                        // Only disable it for the email templates page and not the addition of templates page.
                        if ( !! scope.newEmailContents) {
                            return;
                        }
                    }

                    // This will keep track of the mode in which tinymce should work.
                    scope.$watch('editMode', function(newValue, oldValue) {
                        //disable or enable the rich text editor.
                        if (newValue === oldValue) {
                            return;
                        }
                        if (newValue) {
                            enableTinymce();
                        } else {
                            disableTinymce();
                        }
                        stripLinksFromDuplicateDOM();
                    });

                    //toolbar config options
                    switch(tinymceOptions.displayType){
                        case 'full':
                            toolbarConfig = 'undo redo | styleselect | fontselect | fontsizeselect | bold italic underline | textAlign | bullist numlist | outdent indent | forecolor backcolor | link image media | table | code | Personalize';
                            break;
                        case 'expanded':
                            toolbarConfig = 'styleselect | fontselect | fontsizeselect | bold italic underline | textAlign | bullist numlist | link';
                            break;
                        case 'extended':
                            toolbarConfig = "undo redo | styleselect fontselect fontsizeselect | bold italic | textAlign | bullist numlist | link | fullscreen";
                            break;
                        default:
                            toolbarConfig = 'styleselect | bold italic | textAlign | bullist numlist | link';
                    }

                    if(tinymceOptions.fontConfig){
                        fontConfig = 'Andale Mono=andale mono,times;Open Sans=sans-serif,arial,helvetica;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;Comic Sans MS=comic sans ms,sans-serif;Courier New=courier new,courier;Georgia=georgia,palatino;Helvetica=helvetica;Impact=impact,chicago;Symbol=symbol;Tahoma=tahoma,arial,helvetica,sans-serif;Terminal=terminal,monaco;Times New Roman=times new roman,times;Trebuchet MS=trebuchet ms,geneva;Verdana=verdana,geneva;Webdings=webdings;Wingdings=wingdings,zapf dingbats;Garamond=Garamond,serif;Brush Script MT=Brush Script MT,cursive';
                    } else {
                        fontConfig = 'Andale Mono=andale mono,times;Open Sans=sans-serif,arial,helvetica;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;Comic Sans MS=comic sans ms,sans-serif;Courier New=courier new,courier;Georgia=georgia,palatino;Helvetica=helvetica;Impact=impact,chicago;Symbol=symbol;Tahoma=tahoma,arial,helvetica,sans-serif;Terminal=terminal,monaco;Times New Roman=times new roman,times;Trebuchet MS=trebuchet ms,geneva;Verdana=verdana,geneva;Webdings=webdings;Wingdings=wingdings,zapf dingbats';
                    }

                    if(tinymceOptions.menuOptions === 'extendedMenu'){
                        menubarConfig = {
                            file: {title: 'File', items: 'print'},
                            edit: {title: 'Edit', items: 'undo redo | selectall | searchreplace'},
                            insert: {title: 'Insert', items: 'link | charmap | hr'},
                            view: {title: 'View', items: 'visualaid visualchars visualblocks | fullscreen'},
                            format: {title: 'Format', items: 'bold italic underline strikethrough superscript subscript | formats | removeformat'},
                            table: {title: 'Table', items: 'inserttable tableprops deletetable | cell row column'},
                            tools: {title: 'Tools', items: ' code'}
                        };
                    }

                    function renderTinyMce() {
                        var options = {
                            // General options
                            mode: 'exact',
                            elements: $(element).prop('id'),
                            theme: 'modern',
                            plugins: [
                                'advlist autolink lists link image charmap print preview hr anchor pagebreak',
                                'searchreplace visualblocks visualchars code fullscreen',
                                'insertdatetime media nonbreaking save table directionality',
                                'emoticons template paste'
                            ],
                            font_formats: fontConfig,
                            paste_retain_style_properties: tinymceOptions.retainPasteProperty ? 'color font-size font-family background-color border border-top border-right border-bottom border-left background line-height text-align text-justify height tab-stops margin-left text-autospace' : '',
                            toolbar: scope.toolbarConfig || toolbarConfig,
                            browser_spellcheck: true,
                            selector: 'textarea',
                            image_advtab: true,
                            height: attribute.height || '240px',
                            width: attribute.width,
                            plugin_preview_height: attribute.height || '240px',
                            plugin_preview_width: '990px',
                            valid_elements: '*[*]',
                            extended_valid_elements: '*[*]',
                            convert_urls: false,
                            menubar: tinymceOptions.menubar || false,
                            menu: menubarConfig || undefined, // <-- changed: avoid invalid 'false' for v6
                            statusbar: tinymceOptions.statusbar || false,
                            valid_children : '+body[link]',
                            content_css: '/__assets__/styles/tinymce-templates/jv.tinymceContentOverride.css',
                            forced_root_block : 'div', // <-- changed: v6 requires non-empty string
                            formats: {
                                alignright: [
                                    // removed figure.image format that was causing issues with inline content
                                    {
                                        selector: 'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',
                                        styles: {
                                            textAlign: 'right'
                                        },
                                        inherit: false,
                                        defaultBlock: 'div'
                                    },
                                    {selector: 'img,table', collapsed: false, styles: {'float': 'right'}}
                                ]
                            },
                            //This is needed to strip html when we paste from outlook but if set to true we loose formatting when we paste from else where
                            //paste_as_text: true,
                            setup: function(ed) {
                                var editorContentFilter = {
                                    setContent: function(originalContent) {
                                        var headMatch,
                                            headText,
                                            stylesMatch,
                                            styleText,
                                            pattern;
                                        if(originalContent){
                                            headMatch = originalContent.match(/<head>(.|\n|\r)*?<\/head>/i);
                                            if (headMatch) {
                                                headText = headMatch[0];
                                                stylesMatch = headText.match(/<link(.|\n|\r)*?>/ig);
                                                if (stylesMatch) {
                                                    styleText = '';
                                                    for (var i = 0; i < stylesMatch.length; i++) {
                                                        styleText += stylesMatch[i];
                                                    }
                                                    originalContent = originalContent.replace(/<body((.|\n|\r)*?)>/gi, '<body$1><!--link begin-->' + styleText + '<!--link end-->');
                                                }
                                            }
                                            /*
                                             * replacing newline text with <br> tag based on a flag.
                                             * Default behaviour is to replace the \n with <br>
                                             * Detecting if content contains HTML so that it will not replace \n with <br/> since tinyMCE automatically adds <br/> with in editor.
                                             */
                                            if(!tinymceOptions.dontEscapeNewline){

                                                //Commenting out the fix for copy paste --NV. Since this will break for templates that have <Name> in them
                                                //var regEx = /<(?:"[^"]*"['"]*|'[^']*'['"]*|[^'">])+>/;
                                                //if(!regEx.test(originalContent)){
                                                /*
                                                Only replace '\n' for non-html content. Mailny for templates that come from admin which is .NET and has no tinymce.
                                                When we copy paste form outlook we get full page html with '\n' in the content. But it also has its own style.Hence we dont want to strip '\n'.
                                                When we dont copy paste and get html from the backend we cannot check for each html tag so we will set a flag from JSP to avoid replacing '\n'.
                                                */
                                                var toSearch = '\n';
                                                var toReplace = '<br/>';
                                                originalContent = originalContent.split(toSearch).join(toReplace);
                                                //}
                                            }
                                            return originalContent;
                                        }
                                        return '';
                                    },
                                    getContent: function(originalContent) {
                                        return originalContent.replace(/<!--link begin-->(.|\n|\r)*?<!--link end-->/g, '');
                                    }
                                };

                                ed.on('BeforeSetContent', function(ed, o) {
                                    ed.content = editorContentFilter.setContent(ed.content);
                                });
                                ed.on('GetContent', function(ed, o) {
                                    ed.content = editorContentFilter.getContent(ed.content);
                                });

                                ed.on('SetContent', function (e) {
                                    if(!e.initial){
                                        ed.save();
                                        updateModel();
                                    }
                                });

                                ed.on('change', function(e) {
                                    //NV:used to track when onchage is fired
                                    if(!scope.$parent.tokenAdded){
                                        scope.$parent.tokenEdited = true;
                                    }else{
                                        scope.$parent.tokenEdited = false;
                                    }
                                    updateModel();
                                });

                                var keyUpTimer = null;
                                ed.on('KeyUp', function(e) {
                                    if (keyUpTimer) {
                                        $timeout.cancel(keyUpTimer);
                                    }
                                    keyUpTimer = $timeout(updateModel, 200);
                                });
                                // Update model on button click
                                ed.on('ExecCommand', function () {
                                    ed.save();
                                    updateModel();
                                });
                                // Additional buttons
                                // --- v4 -> v6 shim (must be before any ed.addButton calls)
                                if (!ed.addButton && ed.ui && ed.ui.registry) {
                                    ed.addButton = function(name, spec) {
                                      if (spec && spec.type === 'menubutton') {
                                        ed.ui.registry.addMenuButton(name, {
                                          text: spec.text,
                                          icon: spec.icon,
                                          tooltip: spec.tooltip,
                                          fetch: function (cb) {
                                            const items = (spec.menu || []).map(function(m) {
                                              return {
                                                type: 'menuitem',
                                                text: m.text,
                                                icon: m.icon,
                                                onAction: m.onclick || function() {}
                                              };
                                            });
                                            cb(items);
                                          }
                                        });
                                      } else {
                                        ed.ui.registry.addButton(name, {
                                          text: spec && spec.text,
                                          icon: spec && spec.icon,
                                          tooltip: spec && spec.tooltip,
                                          onAction: (spec && spec.onclick) || function() {}
                                        });
                                      }
                                    };
                                }

                                //Personalize button can be removed based on the flag.
                                if(tinymceOptions.personalize){
                                    ed.addButton('Personalize', {
                                        text: 'Personalize',
                                        type: 'menubutton',
                                        tooltip: 'Personalize',
                                        context: 'textAlign',
                                        menu: [{
                                            text: 'Video Actual Url',
                                            onclick: function() {
                                                ed.insertContent('<a href=\"[video-actual-url]\">Let\'s Get Started</a>');
                                            }
                                        }, {
                                            text: 'Video Practice Url',
                                            onclick: function() {
                                                ed.insertContent('<a href=\"[video-practice-url]\">Take Practice Interview</a>');
                                            }
                                        }, {
                                            text: 'Video Questionnaire Name',
                                            onclick: function() {
                                                ed.insertContent('[video-questionnaire-name]');
                                            }
                                        } , {
                                            text: 'Video Total Time',
                                            onclick: function() {
                                                ed.insertContent('[video-total-time]');
                                            }
                                        } , {
                                            text: 'Video Expiration Date',
                                            onclick: function() {
                                                ed.insertContent('[video-expiration-date]');
                                            }
                                        }, {
                                            text: 'Job Company Name',
                                            onclick: function() {
                                                ed.focus();
                                                ed.insertContent('[job-company-name]');
                                            }
                                        }, {
                                            text: 'Job Title',
                                            onclick: function() {
                                                ed.insertContent('[job-title]');
                                            }
                                        }, {
                                            text: 'Candidate First Name',
                                            onclick: function() {
                                                ed.insertContent('[candidate-first-name]');
                                            }
                                        }, {
                                            text: 'Candidate Last Name',
                                            onclick: function() {
                                                ed.insertContent('[candidate-last-name]');
                                            }
                                        }, {
                                            text: 'Sender Signature',
                                            onclick: function() {
                                                ed.insertContent('[sender-signature]');
                                            }
                                        } , {
                                            text: 'Recruiter First Name',
                                            onclick: function() {
                                                ed.insertContent('[recruiter-first-name]');
                                            }
                                        } , {
                                            text: 'Recruiter Last Name',
                                            onclick: function() {
                                                ed.insertContent('[recruiter-last-name]');
                                            }
                                        } , {
                                            text: 'Hiring Manager First Name',
                                            onclick: function() {
                                                ed.insertContent('[hiring-manager-first-name]');
                                            }
                                        } , {
                                            text: 'Hiring Manager Last Name',
                                            onclick: function() {
                                                ed.insertContent('[hiring-manager-last-name]');
                                            }
                                        }]
                                    });
                                }
                                if (scope.onSetup) {
                                    scope.onSetup({ editor: ed });
                                }
                            },
                            oninit: onInit
                        };
                        if (tinymceOptions.allHtml) {
                            angular.extend(options, {
                                theme_advanced_buttons3_add: 'fullpage',
                                fullpage_fontsizes: '13px,14px,15px,18pt,xx-large',
                                fullpage_default_xml_pi: false,
                                fullpage_default_langcode: 'en',
                                fullpage_default_title: 'Jobvite'
                            });
                            //Include the fullapge plugins only if the all-html attribute is provided.
                            options.plugins.push('fullpage');
                        }
                        //small icons
                        if(tinymceOptions.smallIcons){
                            options.toolbar_items_size = 'small';
                        }
                        // Removed Formats > Inline > code & Formats > Blocks > Div for limitted option views
                        if(tinymceOptions.displayType !== 'full'){
                            styleFormatItems = [
                                {
                                    title: 'Headers',
                                    items: [
                                        {
                                            title: 'Header 1',
                                            format: 'h1'
                                        },
                                        {
                                            title: 'Header 2',
                                            format: 'h2'
                                        },
                                        {
                                            title: 'Header 3',
                                            format: 'h3'
                                        },
                                        {
                                            title: 'Header 4',
                                            format: 'h4'
                                        },
                                        {
                                            title: 'Header 5',
                                            format: 'h5'
                                        },
                                        {
                                            title: 'Header 6',
                                            format: 'h6'
                                        }
                                    ]
                                },
                                {
                                    title: 'Inline',
                                    items: [
                                        {
                                            title: 'Bold',
                                            icon: 'bold',
                                            format: 'bold'
                                        },
                                        {
                                            title: 'Italic',
                                            icon: 'italic',
                                            format: 'italic'
                                        },
                                        {
                                            title: 'Underline',
                                            icon: 'underline',
                                            format: 'underline'
                                        },
                                        {
                                            title: 'Strikethrough',
                                            icon: 'strikethrough',
                                            format: 'strikethrough'
                                        },
                                        {
                                            title: 'Superscript',
                                            icon: 'superscript',
                                            format: 'superscript'
                                        },
                                        {
                                            title: 'Subscript',
                                            icon: 'subscript',
                                            format: 'subscript'
                                        }
                                    ]
                                },
                                {
                                    title: 'Blocks',
                                    items: [
                                        {
                                            title: 'Paragraph',
                                            format: 'p'
                                        },
                                        {
                                            title: 'Blockquote',
                                            format: 'blockquote'
                                        },
                                        {
                                            title: 'Pre',
                                            format: 'pre'
                                        }
                                    ]
                                },
                                {
                                    title: 'Alignment',
                                    items: [
                                        {
                                            title: 'Left',
                                            icon: 'alignleft',
                                            format: 'alignleft'
                                        },
                                        {
                                            title: 'Center',
                                            icon: 'aligncenter',
                                            format: 'aligncenter'
                                        },
                                        {
                                            title: 'Right',
                                            icon: 'alignright',
                                            format: 'alignright'
                                        },
                                        {
                                            title: 'Justify',
                                            icon: 'alignjustify',
                                            format: 'alignjustify'
                                        }
                                    ]
                                }
                            ];
                            options.style_formats = styleFormatItems;
                        }
                        /*
                         * Bullet / Number list failed firing on any event, so handled here. This event will run for all tinymce rendered in particular page
                         * but only it matches with current / active tinymce.
                        */
                        $(document).on('click','div.mce-menu-item',function(){
                            if(scope.associatedModel && element.val() !== scope.associatedModel){
                                updateModel();
                            }
                        });
                        //create tinymce instance particular to the element

                        setTimeout(function(){
                            element.tinymce(options);
                        });
                    }
                    setTimeout(function(){
                        renderTinyMce();
                    },100);

                }
            };
            return directiveObject;
        }
    ]).directive('tinyMceEditor', ['$timeout', '$rootScope', function ($timeout, $rootScope) {
    return {
        restrict: 'A',
        require: 'ngModel',
        scope: {
            toolbarConfig: '@jvTinymceToolbarConfig',
            message: '=tinyMceEditor',
            inputModel: '=ngModel',
            editMode: '=jvTinymceEditable',
            renderOnLoad: '=jvRenderOnLoad',
            overrides: '=jvTinymceOverrides',
            onSetup: '&jvTinymceOnSetup'
        },
        link: function (scope, element, attribute, ngModel) {
            var toolbarConfig,
                tinymceOptions,
                menubarConfig,
                fontConfig,
                styleFormatItems;
            //tinymce options
            tinymceOptions = scope.$eval(attribute.jvTinymceOptions) || {};
            switch (tinymceOptions.displayType) {
                case 'full':
                    toolbarConfig = 'undo redo | styles | fontfamily | fontsize | bold italic underline | align | bullist numlist | outdent indent | forecolor backcolor | link image media | table | code | personalize';
                    break;
                case 'expanded':
                    toolbarConfig = 'styles | fontfamily | fontsize | bold italic underline | align | bullist numlist | link';
                    break;
                case 'extended':
                    toolbarConfig = 'undo redo | styles | fontfamily | fontsize | align | bullist numlist | link | fullscreen ';
                    break;
                default:
                    toolbarConfig = 'styles | bold italic | align | bullist numlist | link';
            }
            if (tinymceOptions.menuOptions === 'extendedMenu') {
                menubarConfig = {
                    file: { title: 'File', items: 'print' },
                    edit: { title: 'Edit', items: 'undo redo | selectall | searchreplace' },
                    insert: { title: 'Insert', items: 'link | charmap | hr' },
                    view: { title: 'View', items: 'visualaid visualchars visualblocks | fullscreen' },
                    format: { title: 'Format', items: 'bold italic underline strikethrough superscript subscript | formats | removeformat' },
                    table: { title: 'Table', items: 'inserttable tableprops deletetable | cell row column' },
                    tools: { title: 'Tools', items: ' code' }
                };
            }
            if (tinymceOptions.fontConfig) {
                fontConfig = 'Andale Mono=andale mono,times;Open Sans=sans-serif,arial,helvetica;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;Comic Sans MS=comic sans ms,sans-serif;Courier New=courier new,courier;Georgia=georgia,palatino;Helvetica=helvetica;Impact=impact,chicago;Symbol=symbol;Tahoma=tahoma,arial,helvetica,sans-serif;Terminal=terminal,monaco;Times New Roman=times new roman,times;Trebuchet MS=trebuchet ms,geneva;Verdana=verdana,geneva;Webdings=webdings;Wingdings=wingdings,zapf dingbats;Garamond=Garamond,serif;Brush Script MT=Brush Script MT,cursive';
            } else {
                fontConfig = 'Andale Mono=andale mono,times;Open Sans=sans-serif,arial,helvetica;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;Comic Sans MS=comic sans ms,sans-serif;Courier New=courier new,courier;Georgia=georgia,palatino;Helvetica=helvetica;Impact=impact,chicago;Symbol=symbol;Tahoma=tahoma,arial,helvetica,sans-serif;Terminal=terminal,monaco;Times New Roman=times new roman,times;Trebuchet MS=trebuchet ms,geneva;Verdana=verdana,geneva;Webdings=webdings;Wingdings=wingdings,zapf dingbats';
            }
            // Initialize TinyMCE with the configuration
            $timeout(function () {
                // Generate a unique ID for each TinyMCE instance
                __tinyCounter += 1;                         // <-- changed
                var editorId = 'tiny' + __tinyCounter;      // <-- changed
                element.attr('id', editorId);               // <-- changed
                window.tinyMCE.init({
                    selector: '#' + editorId,               // <-- changed
                    min_height: 100,
                    height: attribute.height || '240px',
                    width: attribute.width,
                    plugin_preview_height: attribute.height || '240px',
                    branding: false,
                    promotion: false,
                    skin: 'default',
                    toolbar: scope.toolbarConfig || toolbarConfig,
                    menubar: tinymceOptions.menubar || false,
                    menu: menubarConfig,
                    font_family_formats: fontConfig,
                    toolbar_mode: 'sliding',
                    contextmenu: false,
                    paste_as_text: false,
                    paste_merge_formats: true,
                    paste_webkit_styles: 'all',
                    browser_spellcheck: true,
                    image_advtab: true,
                    valid_elements: '*[*]',
                    extended_valid_elements: '*[*]',
                    convert_urls: false,
                    font_size_formats: '8pt 9pt 10pt 11pt 12pt 13pt 14pt 16pt 18pt 24pt 36pt 40pt',
                    statusbar: tinymceOptions.statusbar || false,
                    valid_children : '+body[link]',
                    content_style: 'body { font-family: "Open Sans", sans-serif; }',
                    plugins: [ 'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                        'searchreplace', 'visualblocks', 'code', 'fullscreen', 'visualchars',
                        'insertdatetime', 'media', 'table', 'wordcount', 'nonbreaking', 'pagebreak',
                        'emoticons', 'codesample', 'accordion', 'directionality', 'anchor'
                    ],
                    paste_preprocess: (editor, args) => {
                        scope.$emit('textPastedResDesc', { id: attribute.jvFieldId });
                        const OlDecimal = '<ol style="list-style-type:decimal; margin-top:0px">';
                        const OlLAlpha = '<ol style="list-style-type: lower-alpha; margin-top:0px">';
                        const OlUAlpha = '<ol style="list-style-type: upper-alpha; margin-top:0px">';
                        if(/<(div|p|ul|li|ol|span)[\s\S]*>/i.test(args.content)) {
                            var classRegex = args.content.replace(/ class\s*=\s*"[^"]*"/g, '').replace(/ class\s*=\s*[^'"\s>]+/g, '');
                            var modifiedContent = classRegex.replace(/<p([^>]*)>/g, '<div$1>').replace(/<\/p>/g, '</div>');
                            var whiteSpaceCleaned = modifiedContent.replace(/white-space:\s*pre;/gi, '');
                            var extractedListItems = extractListItems(whiteSpaceCleaned);
                            var nestedListHTML = convertToNestedList(extractedListItems);
                            var parsedHtmlContent = nestedListHTML.replace(/<o:p><\/o:p>|<p><\/p>|<o:p>&nbsp;<\/o:p>|/g, '').replace(/mso-[^;'"]+?(?=;|'|")/g, '');
                            var regexForEmptySpan = /<span\s[^>]*><\/span>/g;
                            args.content = parsedHtmlContent.replace(regexForEmptySpan, function(match) {
                                return match.replace('</span>', '&nbsp;</span>');
                            });
                        }

                        // Function to parse the HTML content
                        function parseHTML(html) {
                            var parser = new DOMParser();
                            var doc = parser.parseFromString(html, 'text/html');
                            return doc.body;
                        }
                        function checkListType(inputString) {
                            var match = inputString.match(/mso-list:Ignore">([^<])/);
                            if (match) {
                                var nextCharacter = match[1];
                                if (/^[1-9]$/.test(nextCharacter)) {
                                    return OlDecimal;
                                }
                                if (/^[a-z]$/.test(nextCharacter)) {
                                    return OlLAlpha;
                                }
                                if (/^[A-Z]$/.test(nextCharacter)) {
                                    return OlUAlpha;
                                }
                                return '<ul style="margin-top:0px">';
                            }
                        }
                        function getString(inputString) {
                            var searchString = '<!--[endif]-->';
                            var index = inputString.indexOf(searchString);
                            if (index !== -1) {
                                return inputString.substring(index + searchString.length);
                            }
                            return '';
                        }
                        // Traverse the parsed HTML and extract list items
                        function extractListItems(html) {
                            var parsedHTML = parseHTML(html);
                            var listItems = [];
                            var currentList = null;
                            var paragraphs = Array.from(parsedHTML.children);
                            paragraphs.forEach(function (paragraph) {
                                var listInfo = paragraph.getAttribute('style');
                                var levelMatch = listInfo ? listInfo.match(/mso-list:\s*(\S+)\s*level(\d+)/) : null;
                                if (levelMatch) {
                                    var listType = levelMatch[1];
                                    var listLevel = parseInt(levelMatch[2]);

                                    if (!currentList || (currentList && currentList.level !== listLevel)) {
                                        currentList = { type: listType, level: listLevel, items: [], startTag: checkListType(paragraph.innerHTML) };
                                        listItems.push(currentList);
                                    }
                                    var listItemText = getString(paragraph.innerHTML);
                                    currentList.items.push({ text: listItemText, startTag: checkListType(paragraph.innerHTML) });
                                } else {
                                    currentList = null;
                                    listItems.push({ text: paragraph.outerHTML, startTag: checkListType(paragraph.innerHTML) });
                                }
                            });

                            return listItems;
                        }

                        // Convert extracted list items to nested ul li elements
                        function convertToNestedList(listItems) {
                            var resultHTML = '';
                            var listStarted = true;
                            var currentLevel = 0;
                            var maxLevel = 0;

                            function processItems(items) {
                                var startListTag = (items[0] && items[0].startTag) ? items[0].startTag : '<ul style="margin-top:0px">';
                                if(listStarted){
                                    resultHTML += '<ul style="margin-top:0px">';
                                }
                                items.forEach(function (item) {
                                    resultHTML += '<li>' + item.text + '</li>';
                                    if (item.items && item.items.length > 0) {
                                        processItems(item.items);
                                    }
                                });
                            }
                            listItems.forEach(function (item) {
                                var listClosingTag = (item.startTag && item.startTag.startsWith('<ol')) ? '</ol>' : '</ul>';
                                if (item.level) {
                                    currentLevel = item.level;
                                    if (maxLevel < item.level) {
                                        maxLevel = item.level;
                                    } else {
                                        if (maxLevel > currentLevel) {
                                            listStarted = false;
                                            var lvlDiff = maxLevel - currentLevel;
                                            while (lvlDiff >= 1) {
                                                resultHTML += '</ul>';
                                                lvlDiff--;
                                            }
                                        } else {
                                            listStarted = true;
                                        }
                                    }
                                    processItems(item.items);
                                } else {
                                    resultHTML += '</ul>';
                                    listStarted = true;
                                    currentLevel = 0;
                                    maxLevel = 0;
                                    resultHTML += item.text;
                                }
                            });
                            return resultHTML;
                        }
                    },
                    // Include custom properties
                    setup: function (editor) {
                        editor.on('init', function () {
                            const iframe = document.querySelector('iframe');
                            if (iframe && iframe.id && iframe.id.startsWith('tiny')) {
                                iframe.setAttribute('title', 'tinymce editor');
                            }
                            // Set initial content from ngModel (if available)
                            if (scope.inputModel) {
                                if(!tinymceOptions.dontEscapeNewline){
                                    editor.setContent(checkContentFormatting(scope.inputModel));
                                } else {
                                    editor.setContent(scope.inputModel);
                                }
                            }
                        });
                        editor.on('input', function () {
                            scope.$applyAsync(function () {
                                scope.inputModel = editor.getContent();
                            });
                        });
                        editor.on('change', function () {
                            scope.$applyAsync(function () {
                                scope.inputModel = editor.getContent().replace(/stylesheet/g, '');
                            });
                        });
                        editor.on('blur', function () {
                            const content = editor.getContent().replace(/<(div|p)>\s*(<[^>]*>\s*<\/[^>]*>\s*)*<\/\1>/g, '<$1>&nbsp;</$1>');
                            scope.inputModel = $rootScope.stripNewLines(content);
                            if (!scope.$root.$$phase) {
                                scope.$apply();
                            }
                        });
                        if (scope.onSetup) {
                            scope.onSetup({editor: editor});
                        }
                    }
                });
            }, 100);

            function replaceEscapeSequencesWithHtml(text) {
                return text.replace(/\n/g, '<br>')
                    .replace(/\r/g, '')
                    .replace(/\t/g, '&emsp;')
                    .replace(/\\/g, '\\')
                    .replace(/\'/g, "'")
                    .replace(/\"/g, '"');
            }

            function checkContentFormatting(newVal) {
                var containsFormatting = /[\n\r\t]/.test(newVal);
                if (containsFormatting) {
                    return replaceEscapeSequencesWithHtml(newVal);
                } else {
                    return newVal;
                }
            }

            function updateModel() {
                var ed = window.tinyMCE.get(element[0].id);
                if (!ed) return;
                var editorContent = ed.getContent();
                if (angular.isDefined(tinymceOptions.required)) {
                    ngModel.$setViewValue($rootScope.stripNewLines(editorContent));
                }
                if (editorContent && editorContent !== '') {
                    scope.inputModel = $rootScope.stripNewLines(editorContent);
                }
                if (!scope.$root.$$phase) {
                    scope.$apply();
                }
                stripLinksFromDuplicateDOM();
            }

            function updateEditor(message, field) {
                var currentTinymce;
                if (field) {
                    var getField = document.getElementById('field' + field);
                    currentTinymce = window.tinyMCE.get(getField.firstElementChild.id);
                } else {
                    currentTinymce = window.tinyMCE.get(element[0].id);
                }
                if (currentTinymce) {
                    var oldContent = currentTinymce.getContent();
                    if (angular.isDefined(message) && message !== oldContent) {
                        if ($rootScope.stripNewLines(oldContent) !== message) {
                            if(!tinymceOptions.dontEscapeNewline){
                                currentTinymce.setContent(checkContentFormatting(message));
                            } else {
                                currentTinymce.setContent(message);
                            }
                        }
                    }
                }
                updateModel();
            }
            var tinyMceElem = $('*[tiny-mce-editor]');
            function stripLinksFromDuplicateDOM() {
                //VA: find all the links inside the div and remove them.
                if (tinyMceElem.length > 0) {
                    // remove all the links and styles from the tinymce div otherwise it can interfere with the page.
                    tinyMceElem.find('link').remove();
                    tinyMceElem.find('style').remove();
                }
            }

            scope.$watch('inputModel', function (newVal, oldVal) {
                if (angular.isDefined(newVal) && newVal !== oldVal) {
                    var editor = window.tinyMCE.get(element[0].id);
                    if (editor && $rootScope.stripNewLines(editor.getContent()) !== newVal) {
                        updateEditor(newVal);
                    }
                }
            });

            scope.$on('descfileUploadComplete', function(e, content, field) {
                updateEditor(content, field);
            });

            scope.$watch('message.update', function (newVal, oldVal) {
                if (newVal === true) {
                    updateEditor(scope.message.htmlMessage);
                    scope.message.update = false;
                }
                stripLinksFromDuplicateDOM();
            });

            // Watch for changes in the editMode
            scope.$watch('editMode', function (newValue, oldValue) {
                if (newValue === oldValue) {
                    return;
                }
                var ed = window.tinyMCE.get(element[0].id);
                if (ed && ed.mode && ed.mode.set) {
                    ed.mode.set(newValue ? 'design' : 'readonly'); // v6-friendly
                }
                stripLinksFromDuplicateDOM();
            });

            // cleanup on destroy (fix disappearing editors on candidate switch)
            scope.$on('$destroy', function () {
                var ed = window.tinyMCE.get(element[0].id);
                if (ed && ed.remove) ed.remove();
            });
        }
    };
}]);